// src/mobile/pages/Lookup.tsx
/* ============================================================================
 * Movatic WMS - Mobile | Consulta (Lookup) | CesarFilho 932048016
 * Delega no layout base scan-driven unificado (ADR-0034 F3).
 * Modo 'unico': uma leitura -> resultado fica fixo.
 * ========================================================================== */

import ColetorScanScreen from '../components/ColetorScanScreen'

export default function Lookup() {
  return <ColetorScanScreen mode="unico" titulo="Consulta" />
}
